import { Paper, Stack, iconButtonClasses, styled } from "@mui/material";

const PREFIX = "PaperCandidateObjective";

export const paperCandidateObjectiveClasses = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  headerActions: `${PREFIX}-headerActions`,
  form: `${PREFIX}-form`,
  formActions: `${PREFIX}-formActions`,
};

export const PaperCandidateObjectiveRoot = styled(Paper)(({ theme }) => ({
  [`&.${paperCandidateObjectiveClasses.root}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    [`& .${paperCandidateObjectiveClasses.header}`]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
      [`& .${paperCandidateObjectiveClasses.headerActions}`]: {
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1),
        [`& .${iconButtonClasses.root}`]: {
          padding: theme.spacing(0.5),
        },
      },
    },
    [`& .${paperCandidateObjectiveClasses.form}`]: {
      gap: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      [`& .${paperCandidateObjectiveClasses.formActions}`]: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "end",
        gap: theme.spacing(1),
      },
    },
  },
}));

export const PaperCreateCandidateObjectiveCollapse = styled(Stack)(({ theme }) => ({
  [`& .${paperCandidateObjectiveClasses.form}`]: {
    gap: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    [`& .${paperCandidateObjectiveClasses.formActions}`]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "end",
      gap: theme.spacing(1),
    },
  },
}));
